// Pure helpers for the Clients page — joins the ClientStaff rows (uuid +
// role) against Users to get display names, same shape decoration pattern
// as utils/holidays.js.

// Everyone currently assigned to a client, with their name and client-
// specific role, sorted by name.
export function staffForClient(clientId, clientStaff, users) {
  return clientStaff
    .filter((s) => s.client_id === clientId)
    .map((s) => {
      const user = users.find((u) => u.uuid === s.uuid);
      return { uuid: s.uuid, name: user ? user.name : s.uuid, role: s.role || '' };
    })
    .sort((a, b) => a.name.localeCompare(b.name));
}

// The inverse — every client a given uuid is assigned to, with their role
// on each, sorted by client name. Powers the "Clients" capsules on a
// person's profile (both the self-view and the admin's click-to-view-any-
// teammate popup).
export function clientsForUser(uuid, clientStaff, clients) {
  return clientStaff
    .filter((s) => s.uuid === uuid)
    .map((s) => {
      const client = clients.find((c) => c.client_id === s.client_id);
      return { client_id: s.client_id, name: client ? client.name : s.client_id, role: s.role || '' };
    })
    .sort((a, b) => a.name.localeCompare(b.name));
}
